import { Component, ViewEncapsulation, ViewChild, Input, OnInit, OnDestroy, CUSTOM_ELEMENTS_SCHEMA, HostListener } from '@angular/core';
import {
  PdfViewerComponent,
  LinkAnnotationService,
  BookmarkViewService,
  MagnificationService,
  ThumbnailViewService,
  ToolbarService,
  NavigationService,
  TextSearchService,
  TextSelectionService,
  PrintService,
  AnnotationService,
  FormFieldsService,
  FormDesignerService,
  LoadEventArgs,
  // PageOrganizerService,
  CustomToolbarItemModel
  // PageOrganizerService,
} from '@syncfusion/ej2-angular-pdfviewer';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { ToolbarModule, MenuModule, ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MessageModule } from '@syncfusion/ej2-angular-notifications';
import { SpeedDialItemEventArgs, SpeedDialItemModel, SpeedDialModule, SwitchModule } from '@syncfusion/ej2-angular-buttons';
import { PdfViewerModule, PdfViewerComponent as SyncfusionPdfViewerComponent } from '@syncfusion/ej2-angular-pdfviewer';
import { FabModule } from '@syncfusion/ej2-angular-buttons';
import { SwitchComponent } from '@syncfusion/ej2-angular-buttons';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
// import { WebViewerClass, WebViewerUpdateClass } from './models/webviewer.model';
import { NetworkService } from './services/network.service';
// import { DialogUtility } from '@syncfusion/ej2-popups';
import { Node } from '@alfresco/js-api';
import {
  // AlfrescoApiService,
  AppConfigService
} from '@alfresco/adf-core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';
import { ViewerExtensionInterface } from '@alfresco/adf-extensions';
import { ActivatedRoute } from '@angular/router';

// import { ToolItemSaveAnnotation, ToolItemSaveSign, ToolItemDownloadAnnotation, ToolItemDownloadOriginal, ToolItemOpenHistory } from './utils/toolbar-items';
import { Toolbar_Annotation, Toolbar_NoAnnotation } from './utils/toolbar-settings';

// import { PACKAGE_JSON } from '@alfresco/aca-content/about';

// import { roleSelector } from './utils/permission-role-config';

import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
import { FormsModule } from '@angular/forms';
import { WebviewerExtService } from './webviewer-ext.service';
import { WebViewerClass, WebViewerUpdateClass } from './models/webviewer.model';
import { NotificationService } from '@alfresco/adf-core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import moment from 'moment';
import { ConfirmDialogComponent, PeopleContentService } from '@alfresco/adf-content-services';

import * as pako from 'pako';

import { PdfDocument } from '@syncfusion/ej2-pdf';

@Component({
  standalone: true,
  imports: [
    PdfViewerModule,
    FormsModule,
    MenuModule,
    ToolbarModule,
    DialogModule,
    MessageModule,
    SwitchModule,
    GridModule,
    ButtonModule,
    CommonModule,
    SpeedDialModule
  ],
  selector: 'lib-webviewer-ext',
  templateUrl: 'webviewer-ext.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    LinkAnnotationService,
    BookmarkViewService,
    MagnificationService,
    ThumbnailViewService,
    ToolbarService,
    NavigationService,
    TextSearchService,
    TextSelectionService,
    PrintService,
    AnnotationService,
    FormFieldsService,
    FormDesignerService,
    FabModule
    // PageOrganizerService
  ],

  styleUrls: ['webviewer-ext.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WebviewerExtComponent implements OnInit, OnDestroy, ViewerExtensionInterface {
  // @ViewChild('pdfviewer')
  // public pdfviewerControl: PdfViewerComponent;

  @ViewChild('pdfviewer') public pdfviewerControl: PdfViewerComponent;

  @ViewChild(SyncfusionPdfViewerComponent) public pdfviewerControlChecked!: SyncfusionPdfViewerComponent;

  @ViewChild('switch')
  public switch: SwitchComponent;

  @Input()
  url: string;

  @Input()
  nodeId: string;

  @Input()
  nodeRef: any;

  @Input()
  node: Node;

  // public document = '';
  public isShareLink = false;

  public document: string = '';
  public resource: string = '';

  // public document: string = 'https://cdn.syncfusion.com/content/pdf/pdf-succinctly.pdf';
  // public resource:string = "https://cdn.syncfusion.com/ej2/23.2.6/dist/ej2-pdfviewer-lib";

  globalConfigAnnotation: any;

  toolbarSettings = Toolbar_NoAnnotation;

  // Disable config Annontation
  toolbarSettings2 = Toolbar_NoAnnotation;

  @Input()
  thumbnailsNoHidden = true;

  userId: any;
  userInfo: any;

  selectorPermission: any;
  annotationData: any;
  nodeInfo: any;
  nodeName: any;

  public initialRender = 2;
  deleyTimeout: any;
  isFirstLoad = false;

  public items: SpeedDialItemModel[] = [
    {
      id: 'UseEditAnnotation',
      text: 'Save Annotation',
      iconCss: 'e-icon icons-save-annotation',
      disabled: false
    },
    {
      id: 'DownloadAnnotation',
      text: 'Download With Annotation',
      iconCss: 'e-icon icons-download-with-annotation',
      disabled: false
    },
    {
      id: 'DownloadWatermark',
      text: 'Download With Watermark',
      iconCss: 'e-icon icons-download-with-watermark',
      disabled: false
    },
    {
      id: 'DownloadOriginal',
      text: 'Download Original',
      iconCss: 'e-icon icons-download-original',
      disabled: false
    },
    {
      id: 'HideAnnotation',
      text: 'Hide Annotation',
      iconCss: 'e-icon icons-hide-annotation',
      disabled: false
    },
    {
      id: 'UnhideAnnotation',
      text: 'UnHide Annotation',
      iconCss: 'e-icon icons-unhide-annotation',
      disabled: false
    },
    {
      id: 'SaveRedaction',
      text: 'Save Redaction',
      iconCss: 'e-icon icons-redaction',
      disabled: true
    }
  ];

  public roleSelector = Object.freeze({
    role: {
      Preview: {
        matchRole: ['SITEPREVIEW', 'PREVIEW'],
        Preview: true,
        Upload: false,
        Edit: false,
        DownloadOriginal: false,
        DownloadWatermark: false,
        Delete: false,
        UseEditAnnotation: false,
        UseEditAnnotationAll: false,
        PreviewAnnotation: true,
        DownloadAnnotation: false,
        HideAnnotation: false,
        UnhideAnnotation: false
      },
      DownloadWatermark: {
        matchRole: ['SITECANDOWNLOADWATERMARK', 'CANDOWNLOADWATERMARK'],
        Preview: true,
        Upload: false,
        Edit: false,
        DownloadOriginal: false,
        DownloadWatermark: true,
        Delete: false,
        UseEditAnnotation: false,
        UseEditAnnotationAll: false,
        PreviewAnnotation: true,
        DownloadAnnotation: false,
        HideAnnotation: false,
        UnhideAnnotation: false
      },
      Consumer: {
        matchRole: ['SITECONSUMER', 'CONSUMER'],
        Preview: true,
        Upload: false,
        Edit: false,
        DownloadOriginal: true,
        DownloadWatermark: true,
        Delete: false,
        UseEditAnnotation: false,
        UseEditAnnotationAll: false,
        PreviewAnnotation: true,
        DownloadAnnotation: true,
        HideAnnotation: true,
        UnhideAnnotation: true
      },
      Contributor: {
        matchRole: ['SITECONTRIBUTOR', 'CONTRIBUTOR'],
        Preview: true,
        Upload: true,
        Edit: true,
        DownloadOriginal: true,
        DownloadWatermark: true,
        Delete: true,
        UseEditAnnotation: true,
        UseEditAnnotationAll: false,
        PreviewAnnotation: true,
        DownloadAnnotation: true,
        HideAnnotation: true,
        UnhideAnnotation: true
      },
      Editor: {
        matchRole: ['SITEEDITOR', 'EDITOR'],
        Preview: true,
        Upload: false,
        Edit: true,
        DownloadOriginal: true,
        DownloadWatermark: true,
        Delete: true,
        UseEditAnnotation: true,
        UseEditAnnotationAll: true,
        PreviewAnnotation: true,
        DownloadAnnotation: true,
        HideAnnotation: true,
        UnhideAnnotation: true
      },
      Collaborator: {
        matchRole: ['SITECOLLABORATOR', 'COLLABORATOR'],
        Preview: true,
        Upload: true,
        Edit: true,
        DownloadOriginal: true,
        DownloadWatermark: true,
        Delete: true,
        UseEditAnnotation: true,
        UseEditAnnotationAll: true,
        PreviewAnnotation: true,
        DownloadAnnotation: true,
        HideAnnotation: true,
        UnhideAnnotation: true
      },
      Coordinator: {
        matchRole: ['SITEMANAGER', 'COORDINATOR'],
        Preview: true,
        Upload: true,
        Edit: true,
        DownloadOriginal: true,
        DownloadWatermark: true,
        Delete: true,
        UseEditAnnotation: true,
        UseEditAnnotationAll: true,
        PreviewAnnotation: true,
        DownloadAnnotation: true,
        HideAnnotation: true,
        UnhideAnnotation: true
      }
    }
  });

  // versionApp: any;
  // public packageJson? = inject(PACKAGE_JSON, { optional: true });

  public redactionCount = 0;

  public pageOrganizerSettings = { canDelete: false, canInsert: false, canRotate: true, canCopy: false, canRearrange: true, canImport: false };

  @Input()
  hideSpeedDial = false;

  majorVersionRedaction = false;

  versionableRedaction = false;

  constructor(
    private route: ActivatedRoute,
    public trans: TranslateService,
    public networkService: NetworkService,
    private webviewerExtService: WebviewerExtService,
    private appConfig: AppConfigService,
    public dialog: MatDialog,
    private notificationService: NotificationService,
    // private apiAlfrescoService: AlfrescoApiService,
    private httpClient: HttpClient,
    private peopleContentService: PeopleContentService
  ) {
    const flag = appConfig.get<boolean | string>('canAnnotation.enabled');

    this.globalConfigAnnotation = flag;
    this.majorVersionRedaction = appConfig.get<boolean>('majorVersionRedaction.enabled') || false;
    this.versionableRedaction = appConfig.get<boolean>('versionableRedaction.enabled') || false;
    // this.versionApp = this.packageJson.version;
  }

  nameFile: string;

  // Custom Rotate Toolbar Item
  public toolItem1: CustomToolbarItemModel = {
    prefixIcon: 'e-icons e-transform-left',
    id: 'rotateAnticlockwise',
    tooltipText: 'Custom toolbar item'
  };
  public toolItem2: CustomToolbarItemModel = {
    prefixIcon: 'e-icons e-transform-right',
    id: 'rotateClockwise',
    tooltipText: 'Custom toolbar item'
  };
  public toolItem3: CustomToolbarItemModel = {
    text: 'Rotate All',
    id: 'rotateall',
    tooltipText: 'Custom toolbar item'
  };

  async ngOnInit() {
    console.log('# WebviewerExtComponent');

    console.log('this.hideSpeedDial #webviewer ', this.hideSpeedDial);

    // =============================== Setting ===============================
    createSpinner({
      target: document.getElementById('spinner'),
      width: '70px',
      label: 'Loading.'
    });

    document.addEventListener('keydown', this.disableCtrlP);

    this.deleyTimeout = this.appConfig.get<boolean | any>('deleyTimeoutWebviewer.value');
    if (!this.deleyTimeout) {
      this.deleyTimeout = 1000;
    }

    // =============================== Logic ===============================
    const userInfo = await this.peopleContentService.getCurrentUserInfo().toPromise();
    this.userId = userInfo.id;
    this.userInfo = userInfo;

    this.route.params.subscribe(async (_params) => {
      console.log('_params ', _params);

      if (!this.userId) {
        const userInfo = await this.peopleContentService.getCurrentUserInfo().toPromise();
        this.userId = userInfo.id;
        this.userInfo = userInfo;
      }

      this.nodeId = _params.nodeId;

      console.log('this.nodeId = ', this.nodeId);

      let versionId = '';
      if (_params.versionId) {
        versionId = _params.versionId;
      }

      const urlDocument = this.url.replace(/^\./, '');
      const extractedValue = this.extractValueBetween(urlDocument, '/nodes', '/content');

      if (!this.nodeId && extractedValue) {
        this.nodeId = extractedValue;
        this.hideSpeedDial = true;
        this.thumbnailsNoHidden = false;
      }

      if (this.nodeId) {
        this.nodeInfo = await this.networkService.getNodeInfo(this.nodeId);

        this.nodeName = this.nodeInfo.entry.name;

        console.log('this.nodeInfo ', this.nodeInfo);

        console.log('this.userId ', this.userId);

        const userPermission = await this.webviewerExtService.getUserPermissions(this.nodeInfo, this.userId);

        console.log('userPermission', userPermission);

        this.selectorPermission = await this.webviewerExtService.getSelectorPermissions(userPermission, this.roleSelector.role, this.userId);

        console.log('this.seletorPermission ', this.selectorPermission);

        this.fetchAndProcessAnnotation();

        const renId = 'pdf';
        const isNotPdf = await this.networkService.getNonPdfActive(this.nodeId);
        if (isNotPdf) {
          showSpinner(document.getElementById('spinner'));
          let statusCheck = await this.networkService.getCheckRenditions(this.nodeId, renId);
          if (statusCheck) {
            this.loadRenditionContent(renId);
            return;
          }
          // Create rendition once
          const statusCreate = await this.networkService.createRenditionData(this.nodeId, renId);
          if (!statusCreate) {
            console.log('Failed to create rendition', statusCreate);
            return;
          }

          // Retry checks with delay
          const maxRetriesStatusCheck = 10;
          for (let attempt = 0; attempt < maxRetriesStatusCheck; attempt++) {
            statusCheck = await this.networkService.getRetryCheckRenditions(this.nodeId, renId);
            if (statusCheck) {
              this.loadRenditionContent(renId);
              return;
            }
            await this.sleep(5000); // 5 second delay
          }
        } else {
          this.loadDocument(versionId);
        }
      } else {
        if (urlDocument.includes('shared-links')) {
          this.isShareLink = true;
          await setTimeout(async () => {
            this.document = urlDocument;
          }, this.deleyTimeout);
        }
      }
    });
  }

  // =============================== Orther ===============================

  private sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  template(tpl: any, args: any) {
    return tpl.replace(/\${([A-Za-z0-9.,:-]*)}/g, (_: any, v: any) => {
      return args[v] ? args[v] : '';
    });
  }

  private extractValueBetween(originalString: string, startDelimiter: string, endDelimiter: string): string {
    const startIndex = originalString.indexOf(startDelimiter);
    const endIndex = originalString.indexOf(endDelimiter);

    if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
      let extracted = originalString.substring(startIndex + startDelimiter.length, endIndex);
      extracted = extracted.trim().replace(/^\//, '').replace(/\/$/, '');
      return extracted;
    } else {
      return '';
    }
  }

  alertInfo(infoTxt: string) {
    this.notificationService.showInfo(infoTxt, '', { duration: 1000 }, true);
  }

  alertWarning(infoTxt: string) {
    this.notificationService.showError(infoTxt, '', { duration: 1000 }, true);
  }
  decodeBinaryValue(binaryValue: string): string {
    return atob(binaryValue);
  }

  isLockAnnotation = true;

  remarkAnnotation: any;
  private async fetchAndProcessAnnotation() {
    await this.networkService.getAnnotation(this.nodeId).subscribe(
      (data) => {
        this.remarkAnnotation = data.remark;
        this.annotationData = data.annotation_text;

        console.log('this.annotationData ', this.annotationData);

        if (this.annotationData) {
          const userSave = data.user_save;
          let isLock = true;
          if (this.selectorPermission.UseEditAnnotation && userSave === this.userId) {
            isLock = false;
          }
          if (this.selectorPermission.UseEditAnnotationAll) {
            isLock = false;
          }
          if (isLock) {
            this.selectorPermission.UseEditAnnotation = false;
          }
          this.isLockAnnotation = isLock;
          this.setToobarAnnotation();
          this.setButtonActions();
        } else {
          this.annotationData = null;
          let isLock = true;
          if (this.userId === this.nodeInfo.entry.createdByUser.id && this.selectorPermission.UseEditAnnotation) {
            isLock = false;
          }

          if (this.selectorPermission.UseEditAnnotationAll) {
            isLock = false;
          }
          if (this.selectorPermission.UseEditAnnotation) {
            isLock = false;
          }
          if (isLock) {
            this.selectorPermission.UseEditAnnotation = false;
          }
          this.isLockAnnotation = isLock;
          this.setToobarAnnotation();
          this.setButtonActions();
        }
      },
      (_error) => {
        this.annotationData = null;

        let isLock = true;

        if (this.userId === this.nodeInfo.entry.createdByUser.id && this.selectorPermission.UseEditAnnotation) {
          isLock = false;
        }

        if (this.selectorPermission.UseEditAnnotationAll) {
          isLock = false;
        }

        if (this.selectorPermission.UseEditAnnotation) {
          isLock = false;
        }

        if (isLock) {
          this.selectorPermission.UseEditAnnotation = false;
        }

        this.isLockAnnotation = isLock;

        this.setToobarAnnotation();
        this.setButtonActions();
      }
    );
  }

  private setToobarAnnotation() {
    console.log('this.isLockAnnotation ', this.isLockAnnotation);
    if (!this.isLockAnnotation) {
      this.toolbarSettings = Toolbar_Annotation;
    }
  }

  private setButtonActions() {
    if (this.selectorPermission) {
      const filteredItems = this.items.filter((item) => this.selectorPermission[item.id] !== false && item.id !== 'UnhideAnnotation');
      this.items = filteredItems;
    }
  }

  templateWatermark(tpl: any, args: any) {
    return tpl.replace(/\${([A-Za-z0-9.,:-]*)}/g, (_: any, v: any) => {
      return args[v] ? args[v] : '';
    });
  }

  loadContent = false;
  // =============================== Load document to display ===============================
  private async loadRenditionContent(renId: any) {
    await setTimeout(async () => {
      const base64Data = await this.networkService.getRenditionContent(this.nodeId, renId);
      if (base64Data) {
        hideSpinner(document.getElementById('spinner'));
        // var viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
        // viewer.load(base64Data);
        this.base64String = base64Data;
        this.loadContent = true;
      }
    }, this.deleyTimeout);
  }

  public base64String: string | undefined;

  private async loadDocument(versionId: any) {
    showSpinner(document.getElementById('spinner'));

    if (versionId) {
      return new Promise(() => {
        setTimeout(async () => {
          const base64Data = await this.networkService.downloadNodeVersion(this.nodeId, versionId);
          if (base64Data) {
            hideSpinner(document.getElementById('spinner'));
          }
          // const viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
          // viewer.load(base64Data);
          this.base64String = base64Data;
        }, this.deleyTimeout);
      });
    }

    return new Promise(async () => {
      const base64Data = await this.networkService.downloadNode(this.nodeId);
      if (base64Data) {
        hideSpinner(document.getElementById('spinner'));
      }
      // const viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
      // viewer.load(base64Data);
      this.base64String = base64Data;
      // console.log('globalConfigAnnotation ', this.globalConfigAnnotation);
    });
  }

  isRedaction = false;
  // =============================== Annotation ===============================
  importAnnotaion(_e: LoadEventArgs): void {
    console.log('# importAnnotaion');

    var viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];

    if (this.annotationData) {
      try {
        if (this.remarkAnnotation === 'BINARY') {
          const decompressedAnnotations = pako.inflate(this.annotationData, { to: 'string' });
          this.annotationData = JSON.parse(decompressedAnnotations);
        } else if (this.remarkAnnotation === 'ENDCODE') {
          const decompressedAnnotations = this.decompressAnnotation(this.annotationData);
          viewer.importAnnotation(JSON.parse(decompressedAnnotations));
        } else {
          viewer.importAnnotation(JSON.parse(this.annotationData));
        }

        // console.log('this.userId importAnnontation', this.userId);
        viewer.annotationSettings = {
          author: this.userId,
          minHeight: 0,
          minWidth: 0,
          maxWidth: 0,
          maxHeight: 0,
          isLock: this.isLockAnnotation,
          skipPrint: false,
          skipDownload: false,
          allowedInteractions: ['None']
        };
      } catch (error) {
        console.error('Failed to import annotation:', error);
        this.alertWarning('Failed to import annotation');
      }
    }

    console.log('viewe.annotationCollection ', viewer.annotationCollection);

    viewer.annotationSettings = {
      author: this.userId,
      minHeight: 0,
      minWidth: 0,
      maxWidth: 0,
      maxHeight: 0,
      isLock: this.isLockAnnotation,
      skipPrint: false,
      skipDownload: false,
      allowedInteractions: ['None']
    };

    // for (var x = 0; x < this.pdfviewerControl.formFieldCollections.length; x++) {
    //   this.pdfviewerControl.formDesignerModule.updateFormField(this.pdfviewerControl.formFieldCollections[x].id, {
    //     thickness: 1
    //   } as any);
    // }

    for (var x = 0; x < this.pdfviewerControl.formFieldCollections.length; x++) {
      console.log(this.pdfviewerControl.formFieldCollections[x]);
      if (this.pdfviewerControl.formFieldCollections[x].type.toLowerCase() === 'checkbox') {
        this.pdfviewerControl.formDesignerModule.updateFormField(this.pdfviewerControl.formFieldCollections[x].id, {
          thickness: 1
        } as any);
      }
    } // ENDLOOP
  }

  private export(): Promise<any> {
    return new Promise((resolve, reject) => {
      var viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
      viewer
        .exportAnnotationsAsObject()
        .then((value) => {
          resolve(value);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  encodeAnnotation(data: any): string {
    try {
      // Convert data to JSON string
      const jsonString = JSON.stringify(data);
      // Convert JSON string to Uint8Array
      const uint8Array = new TextEncoder().encode(jsonString);
      // Compress data
      const compressedData = pako.deflate(uint8Array);
      // Convert Uint8Array to binary string
      let binaryString = '';
      for (let i = 0; i < compressedData.length; i++) {
        binaryString += String.fromCharCode(compressedData[i]);
      }
      // Convert binary string to base64
      return btoa(binaryString);
    } catch (error) {
      console.error('Failed to encode annotation:', error);
      throw error;
    }
  }

  decompressAnnotation(base64String: string): any {
    try {
      // Convert base64 to binary string
      const binaryString = atob(base64String);
      const length = binaryString.length;
      const uint8Array = new Uint8Array(length);
      // Convert binary string to Uint8Array
      for (let i = 0; i < length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }
      // Decompress data
      const decompressedData = pako.inflate(uint8Array);
      // Convert back to string and parse JSON
      const jsonString = new TextDecoder().decode(decompressedData);
      return JSON.parse(jsonString);
    } catch (error) {
      console.error('Failed to decompress annotation:', error);
      throw error;
    }
  }

  private async saveAnnotation() {
    var viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    viewer.annotation.setAnnotationMode('None');

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Save Annotation',
        message: `Are you sure you want to save annotation?`
      },
      minWidth: '250px'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === true) {
        showSpinner(document.getElementById('spinner'));

        let annontationTxt = await this.export();

        if (!annontationTxt) {
          this.alertWarning('No Annotation to Save');
          return;
        }

        // Filter out shapeAnnotations with CustomData.source = toggleWhiteOut
        if (annontationTxt) {
          annontationTxt = JSON.parse(annontationTxt);
          Object.keys(annontationTxt.pdfAnnotation).forEach((pageKey) => {
            const page = annontationTxt.pdfAnnotation[pageKey];
            if (page.shapeAnnotation && Array.isArray(page.shapeAnnotation)) {
              page.shapeAnnotation = page.shapeAnnotation.filter((annotation) => {
                return !(annotation.CustomData && annotation.CustomData.source === 'toggleWhiteOut');
              });
            }
          });
        }
        // Compress the annotation text
        // const compressed = this.encodeAnnotation(annontationTxt);
        // console.log('Endcode 1 :', annontationTxt.length)
        // console.log('Endcode 2 :', compressed.length)
        const compressed = JSON.stringify(annontationTxt);
        const dataContextInsert: WebViewerClass = {
          nodeid: this.nodeId,
          nodename: this.nodeInfo.entry.name,
          user_save: this.userId,
          user_update: '',
          annotation_text: compressed,
          value1: '',
          value2: '',
          value3: '',
          value4: '',
          value5: '',
          remark: ''
          // remark: 'ENDCODE'
        };

        const dataContextUpdate: WebViewerUpdateClass = {
          nodeid: this.nodeId,
          nodename: this.nodeInfo.entry.name,
          user_update: this.userId,
          annotation_text: compressed,
          value1: '',
          value2: '',
          value3: '',
          value4: '',
          value5: '',
          remark: ''
          // remark: 'ENDCODE'
        };

        if (!this.annotationData) {
          this.networkService.addAnnotation(dataContextInsert).subscribe({
            next: () => this.alertInfo('Save Annotation Success'),
            error: (error) => console.log(error.error.message)
          });
          hideSpinner(document.getElementById('spinner'));
        } else {
          this.networkService.updateAnnotation(this.nodeId, dataContextUpdate).subscribe({
            next: () => this.alertInfo('Update Annotation Success'),
            error: (error) => console.log(error.error.message)
          });
          hideSpinner(document.getElementById('spinner'));
        }
      }
    });
  }

  // =============================== Unload ===============================

  ngOnDestroy() {
    this.unLoad();
    document.removeEventListener('keydown', this.disableCtrlP);
  }

  unLoad() {
    var viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    viewer.unload();
  }

  // =============================== Event ===============================

  public clicked(args: SpeedDialItemEventArgs) {
    console.log('clicked', args.item.id);
    switch (args.item.id) {
      case 'UseEditAnnotation':
        this.saveAnnotation();
        break;
      case 'DownloadAnnotation':
        this.downloadWithAnnotation();
        break;
      case 'DownloadWatermark':
        this.downloadWithWatermark();
        break;
      case 'DownloadOriginal':
        this.downloadOriginal();
        break;
      case 'HideAnnotation':
        this.hideAnnotation();
        break;
      case 'UnhideAnnotation':
        this.unHideAnnotation();
        break;
      case 'SaveRedaction':
        this.redact();
        break;
      default:
        break;
    }
  }

  public async onActionButtonClick() {
    console.log('Action button clicked');

    let annontationTxt = await this.export();
    if (!annontationTxt) {
      return;
    }

    let isToggleWhiteOut = false;

    if (annontationTxt) {
      annontationTxt = JSON.parse(annontationTxt);
      Object.keys(annontationTxt.pdfAnnotation).forEach((pageKey) => {
        const page = annontationTxt.pdfAnnotation[pageKey];
        if (page.shapeAnnotation && Array.isArray(page.shapeAnnotation)) {
          const hasToggleWhiteOut = page.shapeAnnotation.some(
            (annotation) => annotation.CustomData && annotation.CustomData.source === 'toggleWhiteOut'
          );
          if (hasToggleWhiteOut) {
            isToggleWhiteOut = true;
          }
        }
      });
    }

    // if (!isToggleWhiteOut) {
    //   this.items = this.items.filter((item) => item.id !== 'SaveRedaction');
    //   console.log('Remove SaveRedaction button ', this.items);
    // }

    if (isToggleWhiteOut) {
      // console.log('this.items #2 ', this.items);
      // this.items = this.items.map((item) => {
      //   if (item.id === 'SaveRedaction') {
      //     return { ...item, disabled: false };
      //   }
      //   return item;
      // });
      // console.log('this.items #1 ', this.items);
      console.log('Disabled SaveRedaction button ', this.items);
    }
  }

  annotationUnhideValue: any;

  public Jsondata: any;

  OnExportJson() {
    var proxy = this;
    this.pdfviewerControl.exportAnnotationsAsObject().then(function (value) {
      proxy.Jsondata = value;
    });
  }

  OnImportJson() {
    this.pdfviewerControl.importAnnotation(JSON.parse(this.Jsondata));
  }

  // private async hideAnnotation() {
  //   this.annotationUnhideValue = null;

  //   // const value = await this.export();

  //   var proxy = this;
  //   this.pdfviewerControl.exportAnnotationsAsObject().then(function (value) {
  //     proxy.Jsondata = value;
  //   });

  //   const value = this.Jsondata;

  //   if (!value) {
  //     this.alertWarning('No Annotation to Hide');
  //     return;
  //   }

  //   this.annotationUnhideValue = value;

  //   var viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
  //   if (viewer.annotationSettings.isLock) {
  //     this.alertWarning('You do not have permission to hide annotation');
  //     return;
  //   }

  //   // const listAnnontation = viewer.annotationCollection;
  //   // let i = 0;
  //   // do {
  //   //   const annotation = listAnnontation[i];
  //   //   viewer.annotationModule.deleteAnnotationById(annotation.annotationId);
  //   // } while (listAnnontation.length > 0);

  //   viewer.exportAnnotationsAsObject().then(function () {
  //     viewer.deleteAnnotations();
  //   });

  //   // เอา item ที่มี id = 'HideAnnotation' ออก
  //   this.items = this.items.filter((item) => item.id !== 'HideAnnotation');

  //   // เพิ่ม item ที่มี id = 'UnhideAnnotation'
  //   this.items.push({
  //     id: 'UnhideAnnotation',
  //     text: 'UnHide Annotation',
  //     iconCss: 'e-icon icons-unhide-annotation',
  //     disabled: false
  //   });

  // }

  private async hideAnnotation() {
    this.annotationUnhideValue = null;

    var proxy = this;
    this.pdfviewerControl.exportAnnotationsAsObject().then(function (value) {
      proxy.Jsondata = value;

      if (!value) {
        this.alertWarning('No Annotation to Hide');
        return;
      }

      proxy.annotationUnhideValue = proxy.Jsondata;

      console.log('proxy.annotationUnhideValue ', proxy.annotationUnhideValue);

      var viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
      if (viewer.annotationSettings.isLock) {
        proxy.alertWarning('You do not have permission to hide annotation');
        return;
      }

      viewer.exportAnnotationsAsObject().then(function () {
        viewer.deleteAnnotations();
      });

      // เอา item ที่มี id = 'HideAnnotation' ออก
      proxy.items = proxy.items.filter((item) => item.id !== 'HideAnnotation');
      // เพิ่ม item ที่มี id = 'UnhideAnnotation'
      proxy.items.push({
        id: 'UnhideAnnotation',
        text: 'UnHide Annotation',
        iconCss: 'e-icon icons-unhide-annotation',
        disabled: false
      });
    });
  }

  private async unHideAnnotation() {
    if (!this.annotationUnhideValue) {
      this.alertWarning('No Annotation to UnHide');
      return;
    }

    // var viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    // viewer.importAnnotation(JSON.parse(this.annotationUnhideValue));

    this.pdfviewerControl.importAnnotation(JSON.parse(this.annotationUnhideValue));

    this.annotationUnhideValue = null;

    // เอา item ที่มี id = 'UnhideAnnotation' ออก
    this.items = this.items.filter((item) => item.id !== 'UnhideAnnotation');
    // เพิ่ม item ที่มี id = 'HideAnnotation'
    this.items.push({
      id: 'HideAnnotation',
      text: 'Hide Annotation',
      iconCss: 'e-icon icons-hide-annotation',
      disabled: false
    });
  }

  private downloadWithAnnotation() {
    var viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];

    viewer
      .saveAsBlob()
      .then((blob: Blob) => {
        // const url = window.URL.createObjectURL(blob);
        // const link = document.createElement('a');
        // link.style.display = 'none';
        // link.download = this.nodeInfo.entry.name;
        // link.href = url;
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);

        // ==========================
        const formData = new FormData();
        formData.append('File', blob, this.nodeInfo.entry.name);
        const headers = new HttpHeaders({
          accept: '*/*'
        });

        // ConvertPdfToImage
        // Flatten
        this.httpClient.post(`/api/Pdf/Flatten`, formData, { headers, responseType: 'blob' }).subscribe(
          (watermarkedBlob: Blob) => {
            const url = window.URL.createObjectURL(watermarkedBlob);
            const link = document.createElement('a');
            link.style.display = 'none';
            link.download = this.nodeInfo.entry.name;
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.alertInfo('Download With Annotation Success');
          },
          (error: any) => {
            console.error('Error sending file to API:', error);
          }
        );
      })
      .catch((error: any) => {
        console.error('Error exporting PDF as Blob:', error);
      });
  }

  lineOne: any;
  lineTwo: any;
  displayFormat: any;

  private downloadWithWatermark() {
    var viewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    const date = moment().format('DD/MM/YYYY');
    const time = moment().format('hh:mm:ss');
    const lineOne = this.appConfig.get<string>('watermark.lineOne') || '';
    const lineTwo = this.appConfig.get<string>('watermark.lineTwo') || '';
    this.lineOne = this.template(lineOne, { ...this.userInfo, date, time });
    this.lineTwo = this.template(lineTwo, { ...this.userInfo, date, time });
    const displayFormat = this.appConfig.get<string>('watermark.displayFormat') || 'center';
    this.displayFormat = displayFormat;
    viewer
      .saveAsBlob()
      .then((blob: Blob) => {
        const formData = new FormData();
        formData.append('File', blob, this.nodeInfo.entry.name);
        const headers = new HttpHeaders({
          accept: '*/*'
        });
        this.httpClient
          .post(`/api/Pdf/Watermark?PlacementFile=${displayFormat}&FirstLine=${this.lineOne}&SecondLine=${this.lineTwo}`, formData, {
            headers,
            responseType: 'blob'
          })
          .subscribe(
            (watermarkedBlob: Blob) => {
              // const url = window.URL.createObjectURL(watermarkedBlob);
              const formData2 = new FormData();
              formData2.append('File', watermarkedBlob, this.nodeInfo.entry.name);
              // ConvertPdfToImage
              // Flatten
              this.httpClient.post(`/api/Pdf/Flatten`, formData2, { headers, responseType: 'blob' }).subscribe(
                (watermarkedBlob2: Blob) => {
                  const url = window.URL.createObjectURL(watermarkedBlob2);
                  const link = document.createElement('a');
                  link.style.display = 'none';
                  link.download = this.nodeInfo.entry.name;
                  link.href = url;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  this.alertInfo('Download With Annotation Success');
                },
                (error: any) => {
                  console.error('Error sending file to API #1:', error);
                }
              );
            },
            (error: any) => {
              console.error('Error sending file to API #2:', error);
            }
          );
      })
      .catch((error: any) => {
        console.error('Error exporting PDF as Blob #3:', error);
      });
  }

  private downloadOriginal() {
    this.networkService
      .downloadContent(this.nodeId)
      .then((blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.style.display = 'none';
        link.download = this.nodeInfo.entry.name;
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.alertInfo('Download Original File Success');
      })
      .catch((error) => {
        console.error('Download failed:', error);
      });
  }

  //  =============================== DEV ===============================

  public exportObject: any;
  public OnExportAnnotationsClick() {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    var _this = this;
    pdfviewer.exportAnnotationsAsObject().then(function (value) {
      _this.exportObject = value;
    });
  }

  public OnImportAnnotationsClick() {
    var pdfviewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    pdfviewer.importAnnotation(JSON.parse(this.exportObject));
  }

  public downloadStart(args): void {
    args.cancel = true;
  }

  @HostListener('window:keydown', ['$event'])
  disableCtrlP(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key === 'p') {
      event.preventDefault();
      console.log('Ctrl+P or Command+P has been disabled');
    }
  }

  onToolbarClick(event: any): void {
    console.log('Toolbar button clicked:', event);
    // ตรวจสอบว่าปุ่มที่กดคือปุ่มอะไร
    if (event.item && event.item.id === 'PdfViewer_organize') {
      console.log('Organize PDF button clicked!');
      // เพิ่ม logic ที่คุณต้องการเมื่อกดปุ่มนี้
    }
  }

  public toolbarClick(args: ClickEventArgs): void {
    //var pdfViewer = (<any>document.getElementById('pdfViewer')).ej2_instances[0];
    var proxy = this;
    if (this.pdfviewerControl) {
      // Rotate
      if (args.item && args.item.id === 'rotateClockwise') {
        this.pdfviewerControl.saveAsBlob().then(function (value) {
          var reader = new FileReader();
          reader.readAsDataURL(value);
          reader.onload = () => {
            var data: any = reader.result;
            var base64 = data.split('base64,')[1];
            let pdfDocument = new PdfDocument(base64);
            let page = pdfDocument.getPage(proxy.pdfviewerControl.currentPageNumber - 1); // Provide the required page number index here
            var rotation = page.rotation + 1;
            if (rotation > 4) {
              rotation = 0;
            }
            page.rotation = rotation;
            pdfDocument.saveAsBlob().then((value) => {
              var reader = new FileReader();
              reader.readAsDataURL(value.blobData);
              reader.onload = () => {
                var base64data: any = reader.result;
                proxy.pdfviewerControl.load(base64data, '');
              };
            });
          };
        });
      } else if (args.item && args.item.id === 'rotateall') {
        this.pdfviewerControl.saveAsBlob().then(function (value) {
          var reader = new FileReader();
          reader.readAsDataURL(value);
          reader.onload = () => {
            var data: any = reader.result;
            var base64 = data.split('base64,')[1];
            let pdfDocument = new PdfDocument(base64);

            for (var i = 0; i < proxy.pdfviewerControl.pageCount; i++) {
              let page = pdfDocument.getPage(i);
              var rotation = page.rotation + 1;
              if (rotation > 4) {
                rotation = 0;
              }
              page.rotation = rotation;
            }
            pdfDocument.saveAsBlob().then((value) => {
              var reader = new FileReader();
              reader.readAsDataURL(value.blobData);
              reader.onload = () => {
                var base64data: any = reader.result;
                proxy.pdfviewerControl.load(base64data, '');
              };
            });
          };
        });
      } else if (args.item && args.item.id === 'rotateAnticlockwise') {
        this.pdfviewerControl.saveAsBlob().then(function (value) {
          var reader = new FileReader();
          reader.readAsDataURL(value);
          reader.onload = () => {
            var data: any = reader.result;
            var base64 = data.split('base64,')[1];
            let pdfDocument = new PdfDocument(base64);
            let page = pdfDocument.getPage(proxy.pdfviewerControl.currentPageNumber - 1); // Provide the required page number index here
            var rotation = page.rotation - 1;
            if (rotation < 0) {
              rotation = 3;
            }
            page.rotation = rotation;
            pdfDocument.saveAsBlob().then((value) => {
              var reader = new FileReader();
              reader.readAsDataURL(value.blobData);
              reader.onload = () => {
                var base64data: any = reader.result;
                proxy.pdfviewerControl.load(base64data, '');
              };
            });
          };
        });
      }

      // Redaction

      switch (args.item.id) {
        case 'toggleWhiteOut':
          console.log('toggleWhiteOut', args.item.id);
          this.pdfviewerControl.rectangleSettings.fillColor = '#4b4b4b';
          this.pdfviewerControl.rectangleSettings.strokeColor = '#4b4b4b';
          this.pdfviewerControl.rectangleSettings.author = 'Redaction';
          this.pdfviewerControl.annotation.setAnnotationMode('Rectangle');

          const whiteOutTimestamp = Date.now();
          this.pdfviewerControl.rectangleSettings.customData = {
            source: 'toggleWhiteOut',
            timestamp: whiteOutTimestamp
          };

          console.log('this.pdfviewerControl ', this.pdfviewerControl);
          break;
        case 'toggleRedact':
          console.log(this.redactionCount);
          // if (this.redactionCount > 0) {
          const aa = this;
          this.pdfviewerControl.saveAsBlob().then(function (value) {
            var data = value;
            var reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onload = function (e) {
              var base64String = e.target?.result;
              var xhr = new XMLHttpRequest();
              xhr.open('POST', '/api/Pdf/Redaction', true);
              xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
              var requestData = JSON.stringify({ base64String: base64String });
              xhr.onload = function () {
                if (xhr.status === 200) {
                  aa.pdfviewerControl.load(xhr.responseText, null);
                } else {
                  console.error('Redaction failed:', xhr.statusText);
                }
              };
              xhr.onerror = function () {
                console.error('An error occurred during the redaction:', xhr.statusText);
              };
              xhr.send(requestData);
            };
          });
          this.redactionCount = 0;
          this.updateRedaction();
          // } else {
          //   this.alertInfo('Please select an annotation to redact');
          // }
          break;
      }
    } else {
      console.error('pdfviewerControl is not defined');
    }
  }

  //To update the redaction count
  public updateRedaction() {
    if (this.redactionCount <= 0) {
      const redactElement = document.querySelector('[title="Redact"]');
      if (redactElement) {
        redactElement.classList.add('e-overlay');
      }

      const whiteOutElement = document.querySelector('[title="WhiteOut"]');
      if (whiteOutElement) {
        whiteOutElement.classList.add('e-overlay');
      }
    } else {
      const redactElement = document.querySelector('[title="Redact"]');
      if (redactElement) {
        redactElement.classList.remove('e-overlay');
      }

      const whiteOutElement = document.querySelector('[title="WhiteOut"]');
      if (whiteOutElement) {
        whiteOutElement.classList.remove('e-overlay');
      }
    }
  }

  public annotation;

  public async annotationAdd(e) {
    console.log('annotationAdd', e);

    var pdfAnnotationList = new Array();
    pdfAnnotationList = this.pdfviewerControl.annotationCollection;
    var selectedAnnotationIndex = pdfAnnotationList.findIndex((item) => item.annotationId == e.annotationId);

    console.log('selectedAnnotationIndex', selectedAnnotationIndex);
    console.log('pdfAnnotationList', pdfAnnotationList);

    if (selectedAnnotationIndex != -1) {
      this.annotation = pdfAnnotationList[selectedAnnotationIndex];
      console.log('annotation', this.annotation);
    }

    // Check
    let annontationTxt = await this.export();
    if (!annontationTxt) {
      return;
    }

    let isToggleWhiteOut = false;

    if (annontationTxt) {
      annontationTxt = JSON.parse(annontationTxt);
      Object.keys(annontationTxt.pdfAnnotation).forEach((pageKey) => {
        const page = annontationTxt.pdfAnnotation[pageKey];
        if (page.shapeAnnotation && Array.isArray(page.shapeAnnotation)) {
          const hasToggleWhiteOut = page.shapeAnnotation.some(
            (annotation) => annotation.CustomData && annotation.CustomData.source === 'toggleWhiteOut'
          );
          if (hasToggleWhiteOut) {
            isToggleWhiteOut = true;
          }
        }
      });
    }

    if (isToggleWhiteOut) {
      console.log('this.items #1 ', this.items);
      this.items = this.items.map((item) => {
        if (item.id === 'SaveRedaction') {
          return { ...item, disabled: false };
        }
        return item;
      });
      console.log('this.items #2 ', this.items);
      console.log('Disabled SaveRedaction button ', this.items);
    }
  }

  public async annotationRemove(e) {
    console.log('annotationRemove', e);

    let annontationTxt = await this.export();
    if (!annontationTxt) {
      return;
    }

    let isToggleWhiteOut = false;

    if (annontationTxt) {
      annontationTxt = JSON.parse(annontationTxt);
      Object.keys(annontationTxt.pdfAnnotation).forEach((pageKey) => {
        const page = annontationTxt.pdfAnnotation[pageKey];
        if (page.shapeAnnotation && Array.isArray(page.shapeAnnotation)) {
          const hasToggleWhiteOut = page.shapeAnnotation.some(
            (annotation) => annotation.CustomData && annotation.CustomData.source === 'toggleWhiteOut'
          );
          if (hasToggleWhiteOut) {
            isToggleWhiteOut = true;
          }
        }
      });
    }

    if (isToggleWhiteOut) {
      this.items = this.items.map((item) => {
        if (item.id === 'SaveRedaction') {
          return { ...item, disabled: false };
        }
        return item;
      });
    } else {
      console.log('this.items #1 ', this.items);
      this.items = this.items.map((item) => {
        if (item.id === 'SaveRedaction') {
          return { ...item, disabled: true };
        }
        return item;
      });
    }
  }

  public async redact() {
    // CHeck Redaction
    let annontationTxt = await this.export();
    if (!annontationTxt) {
      this.alertWarning('No Redaction to Save');
      return;
    }

    let isToggleWhiteOut = false;

    if (annontationTxt) {
      annontationTxt = JSON.parse(annontationTxt);
      Object.keys(annontationTxt.pdfAnnotation).forEach((pageKey) => {
        const page = annontationTxt.pdfAnnotation[pageKey];
        if (page.shapeAnnotation && Array.isArray(page.shapeAnnotation)) {
          const hasToggleWhiteOut = page.shapeAnnotation.some(
            (annotation) => annotation.CustomData && annotation.CustomData.source === 'toggleWhiteOut'
          );
          if (hasToggleWhiteOut) {
            isToggleWhiteOut = true;
            return;
          }
        }
      });

      if (!isToggleWhiteOut) {
        this.alertWarning('Redaction cannot be saved');
        return;
      }
    }

    // Save Redaction
    const pdfViewer = this.pdfviewerControl;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Save Redaction',
        message: `Are you sure you want to save redaction?`
      },
      minWidth: '250px'
    });

    // GetnodeInfo
    const nodeInfo = await this.networkService.getNodeInfo(this.nodeId);
    console.log('nodeInfo', nodeInfo);

    const aspectNames = nodeInfo['entry']['aspectNames'];
    console.log('aspectNames', aspectNames);

    // Check if aspectNames contains 'cm:cmisRedaction'
    const versionable = aspectNames.includes('cm:versionable');
    console.log('versionable', versionable);

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === true) {
        // Remove versionable aspect
        if (versionable && !this.versionableRedaction) {
          const newAspectNames = aspectNames.filter((aspect) => aspect !== 'cm:versionable');
          console.log('new aspectNames', newAspectNames);
          this.networkService.updateNodeProperties(this.nodeId, { aspectNames: newAspectNames }).subscribe({
            next: (response) => {
              console.log('Node updated successfully:', response);
            },
            error: (error) => {
              console.error('Error updating node:', error);
            }
          });
        }

        // Save Redaction
        pdfViewer.saveAsBlob().then((value) => {
          var data = value;
          var reader = new FileReader();
          reader.readAsDataURL(data);
          reader.onload = (e) => {
            var base64String = e.target?.result;
            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/api/Pdf/Redaction', true);
            xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
            var requestData = JSON.stringify({ base64String: base64String });
            xhr.onload = () => {
              if (xhr.status === 200) {
                const contentData = this.dataURItoBlob(xhr.responseText);
                this.networkService.updateNodeContent(this.nodeId, contentData, this.versionableRedaction).subscribe({
                  next: (response) => {
                    this.alertInfo('Redaction saved and file updated in Alfresco successfully');
                    console.log('File updated in Alfresco:', response);
                    pdfViewer.load(xhr.responseText, null);

                    // Update versionable aspect
                    if (versionable && !this.versionableRedaction) {
                      this.networkService.updateNodeProperties(this.nodeId, { aspectNames: aspectNames }).subscribe({
                        next: (response) => {
                          console.log('Node updated successfully:', response);
                        },
                        error: (error) => {
                          console.error('Error updating node:', error);
                        }
                      });
                    }
                  },
                  error: (error) => {
                    console.error('Error updating file in Alfresco:', error);
                    this.alertWarning('Redaction applied but failed to update file in Alfresco');
                  }
                });
              } else {
                console.error('Redaction failed:', xhr.statusText);
              }
            };
            xhr.onerror = function () {
              console.error('An error occurred during the redaction:', xhr.statusText);
            };
            xhr.send(requestData);
          };
        });
        this.redactionCount = 0;
        this.updateRedaction();
      }
    });
  }

  private dataURItoBlob(dataURI: string): Blob {
    // Convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(dataURI.split(',')[1]);
    } else {
      byteString = decodeURIComponent(dataURI.split(',')[1]);
    }

    // Separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // Write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }
}
